import { render, staticRenderFns } from "./TopicFormationDashBoardIndex.vue?vue&type=template&id=4ddb602f&"
import script from "./TopicFormationDashBoardIndex.vue?vue&type=script&lang=js&"
export * from "./TopicFormationDashBoardIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports